import { queryOptions, skipToken } from "@tanstack/react-query";

import { MASTER_INVALIDATION_KEY } from "@/api/queryClient";
import { getMaintenanceStrategyInterval } from "@/api/resources/maintenanceStrategyIntervals/api";
import i18n from "@/providers/i18n";

const entity = i18n.t("interval");
const entityErrorMessage = {
  text: i18n.t("notify.error-reason.unexpected"),
  title: i18n.t("notify.get.error", { e: entity }),
};

export const maintenanceStrategyIntervalsQueryKeys = {
  all: () => [...MASTER_INVALIDATION_KEY, "maintenanceStrategyIntervals"],
  byMaintenanceStrategy: (maintenance_strategy_id?: string) => [
    maintenanceStrategyIntervalsQueryKeys.all(),
    "byMaintenanceStrategy",
    maintenance_strategy_id,
  ],
};

export const maintenanceStrategyIntervalsQueries = {
  byMaintenanceStrategy: (maintenance_strategy_id?: string) =>
    queryOptions({
      queryKey: [...maintenanceStrategyIntervalsQueryKeys.byMaintenanceStrategy(maintenance_strategy_id)],
      queryFn: maintenance_strategy_id
        ? () => getMaintenanceStrategyInterval({ match: { maintenance_strategy_id } })
        : skipToken,

      meta: {
        errorMessage: entityErrorMessage,
      },
    }),
};
